import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { NavigationService } from '../../services/navigation.service';
import { EnrollmentService } from '../../services/enrollment.service';
import { MatDialog } from '@angular/material/dialog';
import { ForgotConfirmationComponent } from '../../reusable-components/forgot-confirmation/forgot-confirmation.component';
import { PersistenceService } from '../../services/persistence.service';
import { Router } from '@angular/router';
import { RememberService } from 'src/app/services/remember.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ModalService } from 'src/app/services/modal.service';
@Component({
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {
  
  today;
  onsite=true;
  active = 2;
  programInfo;
  constructor(
    private persistenceService: PersistenceService,
    private configService: ConfigurationService,
    private modalService: ModalService
  ) {
    this.configService.fetchConfig().then(conf=>{
      this.programInfo = conf;
      this.onsite = conf.onsite;
      if(this.onsite){
        this.active=2;
      }
    });
    this.persistenceService.clear();
    
  }

  ngOnInit(): void { 
    this.today = new Date().toJSON();
  }
  openModal(copy, title, actionButtonText) {
    this.modalService.openModal(copy, title, actionButtonText);
  }


}
